import { useFormik } from "formik";
import React from "react";
import toast from "react-hot-toast";
import { BsChevronLeft } from "react-icons/bs";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import {
  useSendVerificationEmailMutation,
  useVerifyEmailMutation,
} from "../../../features/auth/emailSlice";

export const VerifyEmail = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const [verifyEmail, { isLoading }] = useVerifyEmailMutation();
  const [sendVerificationEmail, { isLoading: isSendVerificationLoading }] =
    useSendVerificationEmailMutation();

  const formik = useFormik({
    initialValues: {
      code: null,
    },
    // validationSchema: LoginSchema,
    onSubmit: async (values) => {
      try {
        toast.loading("Verifying...");
        await verifyEmail({
          email,
          code: values.code,
        }).unwrap();
        toast.dismiss();
        toast.success("Email is verified!", { duration: 2000 });
        navigate("/login");
      } catch (error: any) {
        console.log(error);
        toast.dismiss();
        toast.error(error?.message);
      }
    },
  });

  return (
    <div className="login-bg1 w-full font-dashboard bg-[#f8f8f8] h-screen flex justify-center items-center">
      <div className="bg-white w-full max-w-[400px] rounded-md shadow-lg px-5 py-10">
        <h3 className="text-2xl text-indigo-500 font-semibold text-center">
          Gcbuying
        </h3>
        <h4 className="text-lg font-[500] text-slate-600 mt-8">
          Enter 6-digit code 📩
        </h4>
        <p className="text-sm text-slate-500 mt-1">
          Check your email. Enter the code you received via this email:{" "}
          {/* <span className='font-semibold'>{email}</span> */}
        </p>
        <p className="text-xs text-slate-400 mt-1">
          Can't find the code? Please check your spam or junk folder.
        </p>

        <form action="" className="mt-6" onSubmit={formik.handleSubmit}>
          <div className="flex flex-col gap-1">
            <label htmlFor="code" className="text-xs text-slate-600">
              Code
            </label>
            <input
              type="number"
              name="code"
              id="code"
              value={formik.values.code || ""}
              onChange={formik.handleChange}
              placeholder=""
              className="transition-all duration-200 px-4 py-2 rounded-md text-sm border border-slate-300 focus:outline-none focus:ring-1 focus:ring-indigo-500 spin-button-none"
            />
            <p className="text-red-500 text-xs">
              {formik.touched.code &&
                Boolean(formik.errors.code) &&
                formik.errors.code}
            </p>
          </div>

          <button
            type="submit"
            className="mt-4 transition-all duration-200 w-full py-2 text-sm rounded-md text-white font-semibold bg-indigo-500 hover:brightness-105"
          >
            Verify
          </button>

          <button
            type="button"
            className="text-indigo-500 mt-2 text-sm"
            onClick={async () => {
              try {
                toast.loading("Sending verification code...");
                await sendVerificationEmail({ email });
                toast.dismiss();
                toast.success(
                  "A code has been sent to your mail successfully!"
                );
              } catch (error: any) {
                console.log(error?.data.message);
                toast.dismiss();
                toast.error(error?.data.message);
              }
            }}
          >
            Resend code
          </button>

          <Link to="/login">
            <button
              type="button"
              className="text-sm text-indigo-500 flex items-center mt-4 gap-2"
            >
              <BsChevronLeft className="text-md text-indigo-500" /> Back to
              login
            </button>
          </Link>
        </form>
      </div>
    </div>
  );
};
